import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { circlesQuery, forViewer, viewerIdOf } from "../services/queries";

export const useCircles = () => {
  const { user, token } = useAuth();

  return useQuery({
    ...forViewer(circlesQuery(user?.schoolId, token), viewerIdOf(user)),
    enabled: !!user?.schoolId && !!token,
  });
};
